export default "__VITE_ASSET__1368ed54__"